import React from 'react';
import { MessageCircle } from 'lucide-react';

// Opens a WhatsApp chat with this person (Indian 10-digit numbers get the 91 prefix).
export const WhatsAppChatLink = ({ phone, testId }) => {
  let digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length === 10) digits = `91${digits}`;
  return (
    <a href={`https://wa.me/${digits}`} target="_blank" rel="noopener noreferrer" title="Chat on WhatsApp"
      className="inline-flex items-center justify-center min-w-[44px] min-h-[44px] text-green-600 hover:text-green-700"
      data-testid={testId} onClick={(e) => e.stopPropagation()}>
      <MessageCircle className="w-[18px] h-[18px]" />
    </a>
  );
};
